<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('tank_types.create')" @invoke-method="invokeMethod($event)" action="showTankType"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetTankTypes()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="$t('lang.active_only')"
                                                true-value="1"
                                                false-value="all"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="tank_types" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showTankType(props.item)">
                                <!-- <td>{{ props.item.image_url }}</td> -->
                                <td><img :src="props.item.image_url" @error="imageLoadError" class="img-table" style="max-width: 75px" /></td>
                                <td>{{ props.item.tank_type }}</td>
                                <td>{{ props.item.formula ? [...props.item.formula].sort().join(", ") : "" }}</td>
                                <td>{{ props.item.comments || $t("lang.none") }}</td>
                                <td class="text-center">
                                    <v-icon :color="props.item.status == '1' ? 'success' : 'error'">{{ props.item.status == "1" ? "check" : "close" }}</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="tank_type"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="tank_type_dialog" :max-width="img_width" id="tankTypeDialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField("tank_type_id") ? $t("lang.edit_tank_type") : $t("lang.add_tank_type") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeTankTypeDialog"
                            :dialog-status="tank_type_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="tank_type">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-switch
                                            v-model="tank_type.status"
                                            :label="tank_type.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                            true-value="1"
                                            false-value="0"
                                            ripple
                                        ></v-switch>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="tank_type_dialog"
                                            v-model="tank_type.tank_type"
                                            :label="`${$t('lang.tank_type')} *`"
                                            :counter="showCounter(tank_type.tank_type, 'tank_type.tank_type')"
                                            :rules="ifValid('tank_type.tank_type')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_type.slug"
                                            :label="`${$t('lang.slug')} *`"
                                            :counter="showCounter(tank_type.slug, 'tank_type.slug')"
                                            :rules="ifValid('tank_type.slug')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="tank_type.formula"
                                            :label="`${$t('lang.formula')} *`"
                                            :items="formula"
                                            item-text="text"
                                            item-value="value"
                                            :rules="ifValid('tank_type.formula')"
                                            hide-selected
                                            multiple
                                            chips
                                        >
                                            <template slot="selection" slot-scope="data">
                                                <v-chip :selected="data.selected" close class="chip--select-multi" @input="remove(data.item)">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title>{{ data.item.text }}</v-list-tile-title>
                                                    </v-list-tile-content>
                                                </v-chip>
                                            </template>
                                        </bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="tank_type.comments"
                                            :label="$t('lang.comments')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('tank_type.comments')"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_type.image_url"
                                            :label="`${$t('lang.image_url')} *`"
                                            :counter="showCounter(tank_type.image_url, 'tank_type.image_url')"
                                            :rules="ifValid('tank_type.image_url')"
                                            @focus="$event.target.select()"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 v-if="!imageLoadError && image_prefix" pa-0 align-center justify-center style="min-height: 56px">
                                        <img
                                            id="tankPhoto"
                                            :src="image_prefix + '/' + image_ending"
                                            max-height="300px"
                                            class="mx-auto"
                                            @error="imageLoadError = true"
                                            @load="checkWidth"
                                        />
                                    </v-flex>
                                    <v-flex xs12 mx-auto v-else align-center text-center font-2x grey--text>
                                        {{ $t("lang.insert_image_view") }}
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('tank_type_id')" color="error" @mouseup.left="$refs.delete_tank_type.openDialog()">{{
                            $t("lang.delete")
                        }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeTankTypeDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyTankType(currObjField('tank_type_id') ? 'patch' : 'post', currObjField('tank_type_id'))">{{
                            $t("lang.save")
                        }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_tank_type"
                :heading="$t('lang.delete_tank_type')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyTankType('delete', currObjField('tank_type_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: "", sortable: false, width: "5%" },
                {
                    text: this.$t("lang.tank_type"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.formula"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.comments"),
                    sortable: false,
                    width: "30%",
                },
                {
                    text: this.$t("lang.active"),
                    sortable: false,
                    width: "15%",
                    align: "center",
                },
            ],
            formula: [
                { value: "l", text: this.$t("lang.length") },
                { value: "w", text: this.$t("lang.width") },
                { value: "h", text: this.$t("lang.height") },
                { value: "d", text: this.$t("lang.diameter") },
            ],
            tank_type: {
                image_url: "",
                tank_type: "",
                formula: [],
                comments: "",
                slug: "",
                status: "1",
            },
            current_obj: null,
            filter: {
                search: "",
                status: "1",
                page_size: 0,
                page_num: 0,
            },
            tank_type_dialog: false,
            imageLoadError: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showTankType" },
                { title: this.$t("lang.refresh"), action: "dbGetTankTypes" },
            ],
            img_width: 500,
            image_prefix: "",
            image_ending: "",
            dbGetTankTypes: _.debounce(this.getTankTypes, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchTankType", {
                url: "tank_types",
                method: "get",
                stateProperty: "tank_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_types) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchTankType", {
                url: "tank_types",
                method: "get",
                stateProperty: "tank_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.tank_types) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_tank_type: (state) => state.validation.rules_tank_type,
            default_filter: (state) => state.tank_types.tank_types_filter,
            page: (state) => state.tank_types.page,
            tank_types: (state) => state.tank_types.tank_types,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    watch: {
        "tank_type.image_url": _.debounce(function (val, oldVal) {
            this.imageLoadError = !/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(val);
            if (!val) {
                this.img_width = 500;
            }
            this.image_ending = val;
        }, 500),
    },
    methods: {
        checkWidth() {
            this.$nextTick(() => {
                if (!!this.tank_type.image_url && !this.imageLoadError && this.tank_type_dialog) {
                    const img = document.getElementById("tankPhoto");
                    if (+img.clientWidth != this.img_width) {
                        if (img.clientWidth > 500) {
                            this.img_width = img.clientWidth + 30;
                        } else {
                            this.img_width = 500;
                        }
                    }
                }
            });
        },
        closeTankTypeDialog() {
            this.tank_type_dialog = false;
            this.$refs.delete_tank_type.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getTankTypes() {
            this.startLoader();
            this.$store
                .dispatch("fetchTankType", {
                    url: "tank_types",
                    method: "get",
                    stateProperty: "tank_types",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.tank_type_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyTankType(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("tank_type")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchTankType", {
                                pk: "tank_type_id",
                                id: id,
                                url: `tank_types/${id ? id : ""}`,
                                method: method,
                                stateProperty: "tank_types",
                                mutate: true,
                                body: this.tank_type,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeTankTypeDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showTankType(item = null) {
            this.current_obj = item;

            if (this.$refs.tank_type) item ? this.$refs.tank_type.resetValidation() : this.$refs.tank_type.reset();

            this.$nextTick(() => {
                this.assignObj(this.tank_type, item, this.rules_tank_type);
                const lastIndex = item.image_url ? item.image_url.lastIndexOf("/") : -1;
                this.tank_type.image_url = lastIndex != -1 ? item.image_url.slice(lastIndex + 1) : "";
                this.image_prefix = lastIndex != -1 ? item.image_url.slice(0, lastIndex) : "";
                this.image_ending = lastIndex != -1 ? item.image_url.slice(lastIndex + 1) : "";
                this.tank_type_dialog = true;
            });
        },
        remove(item) {
            const index = this.tank_type.formula.indexOf(item.value);
            if (index >= 0) {
                this.tank_type.formula.splice(index, 1);
            }
        },
    },
};
</script>
